import React from "react";
import { PhotoStrip } from "../components/PhotoStrip";
import Photo1 from "../img/Outtake1.jpg";
import Photo2 from "../img/Outtake2.jpg";
import Photo3 from "../img/Outtake3.jpg";
import Photo4 from "../img/Outtake4.jpg";

export const Photos: React.FC = () => {
  return (
    <>
      <PhotoStrip photos={[Photo1, Photo2, Photo3, Photo4]} imageHeight={385} cols={{ base: 1, sm: 2, lg: 4 }} title="A few choice images from our pregnancy photo shoot!" />
    </>
  );
};

